import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import Icon from './OpenPlayIcon';
import PicklingLogoMark from '../PicklingLogoMark';

const AuthFlowContainer = ({
  children,
  showNavigation = true,
  currentStep = 'intro',
}) => {
  const [scrollProgress, setScrollProgress] = useState(0);
  const containerRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (containerRef.current) {
        const scrollTop = containerRef.current.scrollTop;
        const scrollHeight = containerRef.current.scrollHeight - containerRef.current.clientHeight;
        const progress = scrollHeight > 0 ? (scrollTop / scrollHeight) * 100 : 0;
        setScrollProgress(progress);
      }
    };

    const container = containerRef.current;
    if (container) {
      container.addEventListener('scroll', handleScroll);
      return () => container.removeEventListener('scroll', handleScroll);
    }
  }, []);

  return (
    <div className="relative min-h-screen bg-background">
      {currentStep === 'intro' && (
        <div className="fixed top-0 left-0 right-0 h-1 bg-muted z-toast">
          <div
            className="h-full bg-primary transition-smooth"
            style={{ width: `${scrollProgress}%` }}
          />
        </div>
      )}

      {showNavigation && (
        <header className="fixed top-0 left-0 right-0 z-[1000] bg-card shadow-elevation-1">
          <div className="flex items-center justify-between h-[72px] px-6 max-w-7xl mx-auto">
            <Link to="/" className="flex items-center gap-3">
              <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-primary">
                <PicklingLogoMark size={28} className="text-primary-foreground" />
              </div>
              <span className="text-xl font-semibold font-heading text-foreground">
                Pickle-ing
              </span>
            </Link>

            <div className="flex items-center gap-3">
              {currentStep === 'intro' && (
                <>
                  <Link
                    to="/openplay/user-authentication"
                    className="px-6 py-2 rounded-lg text-foreground hover:bg-muted transition-smooth touch-target font-medium"
                  >
                    로그인
                  </Link>
                </>
              )}
              {currentStep === 'login' && (
                <Link
                  to="/openplay/user-authentication"
                  className="px-6 py-2 rounded-lg bg-primary text-primary-foreground hover:shadow-elevation-2 transition-smooth touch-target font-medium active:scale-97"
                >
                  회원가입
                </Link>
              )}
              {currentStep === 'signup' && (
                <Link
                  to="/openplay/user-authentication"
                  className="px-6 py-2 rounded-lg text-foreground hover:bg-muted transition-smooth touch-target font-medium"
                >
                  로그인
                </Link>
              )}
            </div>
          </div>
        </header>
      )}

      <main
        ref={containerRef}
        className={`${showNavigation ? 'pt-[72px]' : ''} min-h-screen overflow-y-auto`}
        style={{ scrollBehavior: 'smooth' }}
      >
        {children}
      </main>

      {currentStep === 'intro' && scrollProgress > 20 && (
        <button
          onClick={() => {
            containerRef.current?.scrollTo({ top: 0, behavior: 'smooth' });
          }}
          className="fixed bottom-6 right-6 z-sticky flex items-center justify-center w-12 h-12 rounded-full bg-primary text-primary-foreground shadow-elevation-3 hover:shadow-elevation-4 transition-smooth touch-target active:scale-95"
          aria-label="맨 위로"
        >
          <Icon name="ChevronUpIcon" size={24} />
        </button>
      )}
    </div>
  );
};

export default AuthFlowContainer;
